// Importar librerías
import React from 'react';

const BankParameterization = () => {
  // Renderizar componente
  return <h1>POR HACER: CONSULTAR CON LOS ADMINISTRADORES DE LA PÁGINA</h1>;
};

export default BankParameterization;
